export default __webpack_public_path__ + "static/apple-button-924716ad22071ba60ba102ce3df82d64.png";